var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon",style:(_vm.styleObject)},[_c(_vm.classObject,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }